module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch5"
    }
  }, [_vm._v("INFIRMARY")]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("As Deirdre slowly undressed in the tiny privacy cubicle of the ship’s infirmary she heard her father’s warning in her mind. The gnomish little ship’s doctor certainly didn’t look like a smooth-talking bloke, but Deirdre wondered if this medical examination was nothing more than an excuse to see her naked. Peering at the cubicle’s overhead panel of lights, she could not see any obvious signs of a camera. But still …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She piled her clothes and underwear neatly on the little stool beside her and slipped into the shapeless green medical gown that was hanging from a peg on the bulkhead. It barely reached down to her thighs. Then she hesitated. If he’s watching me, she thought, he’ll know that I’m finished undressing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing. Not a sound from beyond the flimsy partition. Deirdre stood there for as long as she could stand it, then cautiously slid the partition aside and stepped back into Dr. Pohan’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He wasn’t even there. Surprised, she didn’t know what to do. She felt slightly ridiculous in the flimsy medical gown. It was a dull olive green, not good for her complexion, she thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“DEPARTURE IN FIVE MINUTES,” announced the speaker set into the overhead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The corridor door slid back and Dr. Pohan came in again, his wrinkled bald face quite serious.“The scanner was off-line,” he said, apologetically. “I had to get a technician to reboot it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre nodded and unconsciously tugged at the hem of her absurdly short garment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The doctor led her down the corridor past three closed and unmarked doors, then pulled open a fourth. It was another small compartment with a glass booth standing in its middle. White medical cabinets lined the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr. Pohan gestured to the booth. “Kindly step inside. This will only take a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wordlessly, Deirdre entered the booth. The doctor shut its transparent door, then went to one of the cabinets. When he opened it, Deirdre saw that a control panel was inside, rows of switches and dials surmounted by a circular display screen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Please stand still and hold your breath,” the doctor called, his back to Deirdre.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She heard a faint buzzing, then a single pinging note.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Very good,” said Dr. Pohan, turning back to her. “You can come out now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s it?” she asked as she stepped out of the booth. “That’s the test?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Complete three-dimensional body scan,” the doctor said, bobbing his head. “Now all we need is a blood sample.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He went to another cabinet, rummaged in a drawer, and pulled out a medical syringe. “This won’t hurt a bit,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre thought otherwise, but she held out her bare arm for him to puncture.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“DEPARTURE IN SIXTY SECONDS,” said the overhead speaker.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("“MAIN DRIVE IGNITION.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Australia")]), _vm._v("’s departure from Ceres was barely noticeable. Fully dressed once again, Deirdre felt a slight jar, nothing more. But then she realized that she was beginning to feel heavy, almost sluggish. The ship’s building up to one "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v(", she told herself as she followed Dr. Pohan back to his office. It’s going to be like this all the way out to Jupiter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre sank gratefully into the chair in front of the doctor’s desk. Dr. Pohan was smiling pleasantly at her as he tilted slightly back in his chair. The tips of his curling mustache almost reached the crinkled corners of his eyes, she saw.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You have been a good patient, Ms. Ambrose.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What happens now?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With a slight shrug, the doctor replied, “Now we wait for the computer to analyze your scan and blood test. That might take a few hours. You are free to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go? Go where?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr. Pohan glanced at his wrist, then answered, “It’s almost the dinner hour. Go to the ship’s lounge. Meet your fellow Jupiter-bound passengers. Your luggage has been delivered to your stateroom, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre felt puzzled. “But I don’t know where the lounge is. I don’t even know where my stateroom is. I’ve just come aboard—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Of course,” said the doctor. “This is all new to you, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With a preening brush of his curly mustache, the doctor rose from his desk and took Deirdre by the hand. She got to her feet, towering over the diminutive Asian, and let him lead her to the corridor door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That way,” said Dr. Pohan, pointing down the passageway to the right. With his other hand he fished a remote control box from his tunic pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Main lounge,” he said to the palm-sized remote.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A series of yellow arrows began flickering along the deck tiles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Follow the arrows,” Dr. Pohan said. “They will lead you to the lounge.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But my stateroom?” Deirdre asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, just ask any of the map displays in the passageways. They’ll show you. It’s simple.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre nodded, but she felt more confused than reassured.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba1d400c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 90
// module chunks = 0